import React, { useState, useEffect } from 'react';
import config from '../config';
import authService from '../services/auth';

const HomeDesktop = () => {
  const [homeText, setHomeText] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLang] = useState(localStorage.getItem('language') || config.languages.default);

  // Logo dalle configurazioni esistenti
  const logo = config.assets.logo;
  
  // QR code usando la configurazione corretta
  const qrCode = config.assets.qrcode;

  // Funzione per rimuovere tag HTML dal testo
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  // Fetch del testo dalla prima sezione della home (stesso sistema di home.js)
  useEffect(() => {
    const fetchSectionDetails = async (sectionId) => {
      try {
        const response = await authService.get(config.API_ENDPOINTS.getParagraph(sectionId, selectedLang));
        return response;
      } catch (error) {
        console.error(`Errore durante il recupero della sezione ${sectionId}:`, error);
        return null;
      }
    };

    const fetchPageContent = async () => {
      try {
        const response = await authService.get(config.API_ENDPOINTS.getPageList(selectedLang));
        const homePage = response.find(page => 
          page.field_tipologia_pagina?.[0]?.value === 'home' && 
          page.langcode?.[0]?.value === selectedLang
        );

        if (homePage && homePage.field_sezioni && homePage.field_sezioni.length > 0) {
          // Prendo solo la prima sezione
          const firstSectionId = homePage.field_sezioni[0].target_id;
          const firstSection = await fetchSectionDetails(firstSectionId);
          
          if (firstSection && firstSection.field_testo_sezione) {
            // Rimuovo i tag HTML dal testo
            const cleanText = stripHtml(firstSection.field_testo_sezione.value || '');
            setHomeText(cleanText);
          }
        }
      } catch (error) {
        console.error('Errore nel caricamento del testo della home:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageContent();
  }, [selectedLang]);

  return (
    <>
      <style jsx="true">{`
        body {
          padding: 0 !important;
        }
      `}</style>
      <div className="desktop-container">
        <section 
          className="d-flex align-items-center justify-content-center bg-white position-relative" 
          style={{ height: '100dvh' }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              {/* Colonna sinistra - Logo e testo */}
              <div className="col-6 d-flex flex-column align-items-start">
                <img 
                  src={logo} 
                  alt={config.app.title} 
                  className="img-fluid mb-4" 
                  style={{ maxWidth: '400px' }} 
                  onError={(e) => {
                    console.error('Errore caricamento logo:', logo);
                    e.target.style.display = 'none';
                  }}
                />
                <p className="fs-5 text-start">
                  {isLoading ? 'Caricamento...' : (homeText || 'Testo non disponibile')}
                </p>
                <p className="fs-5 text-start mt-4">
                  Inquadra il QR code con il tuo smartphone e lasciati guidare in un'esperienza 
                  unica di fruizione dei contenuti.
                </p>
              </div>

              {/* Colonna destra - QR Code */}
              <div className="col-6 d-flex flex-column align-items-center justify-content-center">
                <img
                  src={qrCode}
                  alt={`QR Code ${config.app.title}`}
                  className="img-fluid"
                  style={{ 
                    maxWidth: '300px',
                    width: '100%'
                  }}
                  onError={(e) => {
                    console.error('Errore caricamento QR code:', qrCode);
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HomeDesktop;